import React from 'react';
import {toast} from 'react-toastify';
import {GlobalTranslate} from '../Helpers';
import ButtonBase from '@mui/material/ButtonBase';
import i18next from 'i18next';

const displayMessageShape = ({
                                 message,
                                 onUndo,
                                 customComponentForMessageWrapping,
                             }) =>
    (customComponentForMessageWrapping
        && customComponentForMessageWrapping(message))
    || (onUndo && (
        <div className="toaster-undo-wrapper">
            <span className="px-2">{message}</span>
            <ButtonBase className="btns theme-transparent miw-0 mx-2" onClick={onUndo}>
                {GlobalTranslate.t('Shared:undo')}
            </ButtonBase>
        </div>
    ))
    || message;
export const showSuccess = (
    message,
    {
        position = toast.POSITION.TOP_CENTER,
        type = toast.TYPE.SUCCESS,
        onUndo,
        customComponentForMessageWrapping,
        autoClose = 5000,
        closeButton = true,
        pauseOnHover = true,
        hideProgressBar = false,
        draggable = true,
        rtl = i18next.dir() === 'rtl',
        toastId,
        theme,
        bodyStyle,
        style,
    } = {}
) => {
    toast(
        displayMessageShape({message, onUndo, customComponentForMessageWrapping}),
        {
            position,
            type,
            autoClose,
            closeButton,
            hideProgressBar,
            pauseOnHover,
            draggable,
            rtl,
            theme,
            toastId: toastId || message,
            bodyStyle,
            style,
        }
    );
};

export const showError = (
    message,
    errors = undefined,
    {
        position = toast.POSITION.TOP_CENTER,
        type = toast.TYPE.ERROR,
        onUndo,
        customComponentForMessageWrapping,
        autoClose = 5000,
        closeButton = true,
        pauseOnHover = true,
        hideProgressBar = false,
        draggable = true,
        rtl = i18next.dir() === 'rtl',
        toastId,
        theme,
        bodyStyle,
        style,
    } = {}
) => {
    const localData = errors?.response?.data || errors?.data;
    const localErrors = localData?.errors || localData?.reason;
    const alternativeMessage = localData?.status || localData?.message;
    const localCodeStatusCondition
        = localData
        && localData.identifiers
        && (localData.identifiers.statusCode === 400
            || localData.identifiers.statusCode === 401
            || localData.identifiers.statusCode === 402
            || localData.identifiers.statusCode === 403);
    const localErrorsCondition
        = localErrors
        && !localCodeStatusCondition
        && ((typeof localErrors === 'object' && !Array.isArray(localErrors))
            || (Array.isArray(localErrors) && localErrors.length > 0));
    const toDisplayMessages
        = (localErrorsCondition && (
            <ul className="mb-0">
                {(Array.isArray(localErrors)
                        && localErrors.map((item, index) => (
                            <li key={`errorKey${index + 1}`}>
                                <span>{item.error}</span>
                            </li>
                        )))
                    || Object.entries(localErrors).map(
                        (items, index) =>
                            (Array.isArray(items[1])
                                && items[1].map((item, subIndex) => (
                                    <li key={`${items[0]}${index + 1}-${subIndex + 1}`}>{item}</li>
                                )))
                            || (items[1] && Object.hasOwn(items[1], 'key') && (
                                <li key={`${items[0]}${index + 1}`}>
                                    {items[1].key && <span>{items[1].key}: </span>}
                                    {items[1].value && <span>{items[1].value}</span>}
                                </li>
                            )) || <li key={`${items[0]}${index + 1}`}>{items[1]}</li>
                    )}
            </ul>
        ))
        || alternativeMessage
        || message;
    if (toDisplayMessages)
        toast(
            displayMessageShape({
                message: toDisplayMessages,
                onUndo,
                customComponentForMessageWrapping,
            }),
            {
                position,
                type,
                autoClose,
                closeButton,
                hideProgressBar,
                pauseOnHover,
                draggable,
                rtl,
                theme,
                toastId: toastId || message,
                bodyStyle,
                style,
            }
        );
};

// function showWarn(message, configuration = { autoClose: 3000 }) {
//   toast.warn(message, configuration);
// }
//
// function showInfo(message, configuration = { autoClose: 3000 }) {
//   toast.info(message, configuration);
// }
